import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../http.service';
import { SyncService } from '../../sync.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { FileUploader } from 'carbon-components-angular';

@Component({
	selector: 'upload-files',
	templateUrl: './upload-files.component.html',
	styleUrls: ['./upload-files.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		])
	]
})

export class UploadFilesComponent implements OnInit, OnDestroy {

	@ViewChild(FileUploader) fileUploader!: FileUploader;

	constructor(
		private httpService: HttpService,
		private syncService: SyncService
	) {}

	email = '';
	userData: any = {};
	currentDeal = '';
	currentFiles: any[] = [];

	subscription: any;

	notifySuccess = false;
	notifyError = false;

	uploadUrl = environment.uploadUrl;

	fileTypeItems = [
		{
			'content': 'Annual or Quarterly Report',
			'selected': false
		},
		{
			'content': 'Audit or Financial Statement',
			'selected': false
		},
		{
			'content': 'Capital Account Statement',
			'selected': false
		},
		{
			'content': 'Fund and Portfolio Assets Performance',
			'selected': false
		},
		{
			'content': 'Limited Partnership Agreement',
			'selected': false
		},
		{
			'content': 'Distribution Notice',
			'selected': false
		},
		{
			'content': 'Other',
			'selected': false
		}
	]
	fileTypeItemsContent = this.fileTypeItems.map((item) => item['content'])

	ngOnInit() {

		if (this.subscription) {
			this.subscription.unsubscribe()
		}

		if (this.syncService.authStatus.getValue() !== 'authenticated') {
			this.syncService.updateAuthStatus('unauthenticated');
			this.syncService.updatePage('login');
			return;
		}

		this.syncService.email$.subscribe((email) => {
			this.email = email;
			if (this.email.endsWith('industryventures.com')) {
				this.fileTypeItems = [
					{
						'content': 'Annual or Quarterly Report',
						'selected': false
					},
					{
						'content': 'Audit or Financial Statement',
						'selected': false
					},
					{
						'content': 'Capital Account Statement',
						'selected': false
					},
					{
						'content': 'Limited Partnership Agreement',
						'selected': false
					}
				]
			}
		});

		this.subscription = this.syncService.userData$.subscribe((data) => {
			this.userData = data;
		});

		// this.syncService.userData$.subscribe((userData) => {
		// 	this.userData = userData;
		// });

		this.syncService.currentDeal$.subscribe((currentDeal) => {
			this.currentDeal = currentDeal;
			if (!this.currentDeal) {
				this.currentDeal = this.userData['Deals'][0]['Deal Name'];
			}
		});

		this.syncService.notifySuccess$.subscribe((notifySuccess) => {
			this.notifySuccess = notifySuccess;
		});

		this.syncService.notifyError$.subscribe((notifyError) => {
			this.notifyError = notifyError;
		});

	}

	onDealSelected(deal: any) {
		this.currentDeal = deal;
	}

	onFilesSelected(event: any) {
		if (event.size === 0 || this.syncService.userData.getValue() === 'upload-files') {
			return;
		}
		event.forEach((file: any) => {
			if (!this.currentFiles.includes(file)) {
				this.currentFiles.push(file);
			}
		});

		let numCurrentFiles = 0
		const deals = this.userData['Deals'];
		deals.forEach((deal: any) => {
			deal['Files'].forEach((file: any) => {
				numCurrentFiles += 1;
			});
		});

		// alert(numCurrentFiles)

		if (this.email.endsWith('industryventures.com')) {
			const maxFilesLimit = 20;
			const maxUploadLimit = 5;
			if (numCurrentFiles + maxUploadLimit > maxFilesLimit) {
				const numFilesLeft = maxFilesLimit - numCurrentFiles;
				this.currentFiles = this.currentFiles.slice(0, numFilesLeft);
				this.syncService.updateNotification('info', 'Sandbox users can upload up to ' + maxFilesLimit.toString() + ' files.', 'You have ' + numFilesLeft.toString() + ' remaining.');
			} else {
				if (this.currentFiles.length > maxUploadLimit) {
					this.currentFiles = this.currentFiles.slice(0, maxUploadLimit);
					this.syncService.updateNotification('info', 'Sandbox users can upload up to 5 files at a time.', 'Please upload more files in 30 minutes to an hour.');
				}
			}
		} else {
			if (this.currentFiles.length > 10) {
				this.currentFiles = this.currentFiles.slice(0, 10);
				this.syncService.updateNotification('info', 'We can handle up to 10 files at a time.', 'Please upload more files in 30 minutes to an hour.');
			}
		}
		try {
			event.stopPropagation();
		} catch (error) {}
	}

	onSelectFileTypes(i: number, $event: any) {
		console.log('$event', $event);
		this.currentFiles[i]['File Types'] = $event.map((item: { content: any; }) => item.content);
		this.currentFiles[i]['File Types Invalid'] = !this.currentFiles[i]['File Types'] || this.currentFiles[i]['File Types'].length === 0;
	}

	onReferenceDateSelected(i: number, $event: any) {
		const selectedDate = new Date($event);
		this.currentFiles[i]['Reference Date'] = selectedDate.toISOString().split('T')[0];
		this.currentFiles[i]['Reference Date Invalid'] = false;
	}

	removeFile(fileToDelete: any) {
		this.fileUploader.files.delete(fileToDelete);
		this.currentFiles = this.currentFiles.filter(item => item !== fileToDelete);
		console.log(this.currentFiles);
	}

	validateFile(i: number) {
		this.currentFiles[i]['File Types Invalid'] = !this.currentFiles[i]['File Types'] || this.currentFiles[i]['File Types'].length === 0;
		this.currentFiles[i]['Reference Date Invalid'] = !this.currentFiles[i]['Reference Date'];
	}

	onUploadFiles() {
		if (this.currentFiles.length === 0) {
			return;
		}

		for (let i = 0; i < this.currentFiles.length; i++) {
			this.validateFile(i);
		}
		for (let i = 0; i < this.currentFiles.length; i++) {
			if (this.currentFiles[i]['File Types Invalid'] || this.currentFiles[i]['Reference Date Invalid']) {
				return;
			}
		}
		this.currentFiles.forEach(file => {
			this.httpService.processFile(file, this.currentDeal);
		});

		this.syncService.updateCurrentDeal(this.currentDeal);
		this.syncService.updatePage('files');
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
